import { isDepositBeforeKYC, isSumsubNeeded } from '@utils/AccountAccess/accountKYCStatuses'
import { CommonPaths } from '@utils/path'

import { AccountDetailedDto, isVerificationExpedited } from '@model/AccountDetailedDto'

export const getNextSignupRoute = (account: AccountDetailedDto | undefined): string => {
  if (!account) return '/sign-up'

  if (isDepositBeforeKYC(account) || isVerificationExpedited(account)) {
    return CommonPaths.AccountLoading
  }

  if (isSumsubNeeded(account)) {
    return '/sign-up/verification'
  }

  return `/sign-up/documents-info/${account.id}`
}
